import { useContext } from "react";
import { TerminalModelContext } from "./context";

export const useTerminalModelContextProvider = () => {
  const context = useContext(TerminalModelContext);
  if (!context) {
    throw new Error("No TerminalModelContext context was provided.");
  }
  return context;
};
